import { render, staticRenderFns } from "./supervisor-tasks-report.vue?vue&type=template&id=6f5cd374&"
import script from "./supervisor-tasks-report.vue?vue&type=script&lang=js&"
export * from "./supervisor-tasks-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports